import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { AuthProvider } from 'react-oidc-context';
import { SvgSprite } from '@completeanatomy/ui';
import { AppStateProvider, registerBridge } from '@completeanatomy/common';
import bridge from './utils/Bridge';
import { BridgeProvider } from '@completeanatomy/bridge';
import { kcGateway } from './utils/keycloak';
import { NEXT_URL_STORAGE_KEY } from './pages/AuthCallback';
import { globalVariables } from './config/globalVariables';
import { ConfigProvider } from '@completeanatomy/config';
import { AuthProvider as CompleteAnatomyAuth } from '@completeanatomy/auth';
import { UserServiceProvider } from '@completeanatomy/user';
import { EventBusProvider } from '@completeanatomy/event-bus';
import { AnalyticsServiceProvider } from '@completeanatomy/analytics';

registerBridge(bridge);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isScreenPage =
  window.location.pathname.includes('/screens/') ||
  window.location.pathname === '/';

if (isScreenPage) {
  sessionStorage.setItem(
    NEXT_URL_STORAGE_KEY,
    window.location.pathname + window.location.search
  );
}

if (!process.env.REACT_APP_KC_TOKEN) {
  const originalFetch = window.fetch;

  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const redirectApi = [
      '/h/ca-web',
      '/api',
      '/v1',
      '/assets',
      '/complete_anatomy-userdata',
      '/3d4medical-235405227423-websdk-resources',
    ];
    const currentUrl = input.toString();

    const isModifyRequired = redirectApi.some(api => {
      const isAnotherDomain = currentUrl.includes(api);
      const isContent = currentUrl.includes('/content/v1');
      const isAuth = currentUrl.includes('api/v13');
      const isCookie = currentUrl.includes('cookielaw');

      return isAnotherDomain && !isContent && !isAuth && !isCookie;
    });

    const isTexture = currentUrl.includes('/textures');

    if (isModifyRequired) {
      return originalFetch(globalVariables.apiDomain + currentUrl, init);
    }
    if (isTexture) {
      return originalFetch(globalVariables.userData + currentUrl, init);
    }

    return originalFetch(input, init);
  };
}

// Set up cookie banner
const oneTrustScript = document.createElement('script');

oneTrustScript.type = 'text/javascript';
oneTrustScript.src = globalVariables.cookieSrc;
document.head.appendChild(oneTrustScript);

const otSDKStubScript = document.createElement('script');

otSDKStubScript.type = 'text/javascript';
otSDKStubScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
otSDKStubScript.setAttribute('charset', 'UTF-8');
otSDKStubScript.setAttribute('data-domain-script', globalVariables.cookieId);

document.head.appendChild(otSDKStubScript);

otSDKStubScript.onload = () => {
  //@ts-ignore
  if (window.Optanon && window.Optanon.Alert) {
    //@ts-ignore
    window.Optanon.Alert.showAlert();
  }
};

root.render(
  <AuthProvider userManager={kcGateway.userManager}>
    <AppStateProvider>
      <BridgeProvider>
        <AnalyticsServiceProvider>
          <ConfigProvider>
            <CompleteAnatomyAuth>
              <EventBusProvider>
                <UserServiceProvider>
                  <SvgSprite />
                  <App />
                  <canvas id="model-canvas" />
                </UserServiceProvider>
              </EventBusProvider>
            </CompleteAnatomyAuth>
          </ConfigProvider>
        </AnalyticsServiceProvider>
      </BridgeProvider>
    </AppStateProvider>
  </AuthProvider>
);
